import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http.service';
import { Subject, Observable } from 'rxjs';
import { tap, catchError, shareReplay } from 'rxjs/operators';
import { AppConstants } from 'src/app/constants/app-constants';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class PublishService {
    private authData: any;
    private publishSubject = new Subject();
    publish$: Observable<any> = this.publishSubject.asObservable();

    constructor(private auth: AuthService, private http: HttpService) {
        this.authData = this.auth.getAuthData();
    }

    getScreensData(platformId: any, productId: any) {
        const url = `${environment.apiUrlDomain}/screens/list?productId=${productId}&platformId=${platformId}&status=1`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'PUBLISH_SCREENS_DROPDOWN_GET_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PUBLISH_SCREENS_DROPDOWN_GET_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getPublishPreviewData(
        productId: string,
        platformId: string = '',
        screenId: string = '',
        checkbox: boolean,
        date: string = '',
        startTime: string,
        endTime: string
    ) {
        var dateObject;
        var starttime = startTime;
        var endtime = endTime;
        var currentDate = date;
        var day: any;

        if (date.length != 0) {
            dateObject = new Date(date);
            day = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'][dateObject.getDay()];
        }

        // if (date.length == 0) {
        //     dateObject = new Date();
        // } else {
        //     dateObject = new Date(date);
        // }

        // if (startTime.length == 0) {
        //     starttime = '';
        // }

        // if (endTime.length == 0) {
        //     endtime = '';
        // }

        // if (date.length == 0) {
        //     currentDate = `${dateObject.getFullYear()}-${dateObject.getMonth() + 1 < 10
        //         ? '0' + Number(dateObject.getMonth() + 1)
        //         : Number(dateObject.getMonth() + 1)
        //         }-${dateObject.getDate() < 10 ? '0' + Number(dateObject.getDate()) : Number(dateObject.getDate())}`;
        // }

        // const date = `${dateObject.getFullYear()}-${(dateObject.getMonth() + 1) < 10 ? '0' + Number(dateObject.getMonth() + 1) : Number(dateObject.getMonth() + 1)}-${dateObject.getDate() < 10 ? '0' + Number(dateObject.getDate()) : Number(dateObject.getDate())}`;
        // const time = `${dateObject.getHours() < 10 ? 0 + Number(dateObject.getHours()) : Number(dateObject.getHours())}:${dateObject.getMinutes() < 10 ? 0 + Number(dateObject.getMinutes()) : Number(dateObject.getMinutes())}:${dateObject.getSeconds() < 10 ? 0 + Number(dateObject.getSeconds()) : Number(dateObject.getSeconds())}`;
        let url = '';

        if (date.length == 0 && startTime.length == 0 && endTime.length == 0) {
            url = `${environment.apiUrlDomain}/preview/screens/rails?productId=${productId}&platformId=${platformId}&screenId=${screenId}&status=${checkbox}`;
        } else {
            url = `${environment.apiUrlDomain}/preview/screens/rails?productId=${productId}&platformId=${platformId}&screenId=${screenId}&status=${checkbox}&day=${day}&date=${currentDate}&startTime=${starttime}&endTime=${endtime}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'PUBLISH_DATA_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PUBLISH_DATA_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getPublishModalData(productId: string, platformId: string = '', screenId: string = '') {
        const url = `${environment.apiUrlDomain}/preview/screens/rails?productId=${productId}&platformId=${platformId}&screenId=${screenId}`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'PUBLISH_MODAL_DATA_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PUBLISH_DATA_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    unpublishData(data: any, checkbox: any, productId: any, screenId: any, platformId: any) {
        console.log(data);

        let url = '';

        if (checkbox) {
            console.log('inside unpublished');
            url = `${environment.apiUrlDomain}/preview/unpublish/category/${productId}/${screenId}/${platformId}`;
        } else {
            console.log('inside published');
            url = `${environment.apiUrlDomain}/preview/republish/category/${productId}/${screenId}/${platformId}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .putRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'PUBLISH_UNPUBLISH_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PUBLISH_UNPUBLISH_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getPdpViewData() {
        const url = `${environment.apiUrlDomain}/pdp`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'PUBLISH_DATA_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PUBLISH_DATA_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    updatePdpOrder(data: any) {
        const url = `${environment.apiUrlDomain}/pdp/rearrangeorder`;

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .putRequest(url, headers, data)
            .pipe(
                tap((response: any) => {
                    if (response.status == 201) {
                        this.publishSubject.next({
                            type: 'PUBLISH_REORDER_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PUBLISH_REORDER_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getPlatformData(productId: any) {
        let url = `${environment.apiUrlDomain}/platforms`;
        const queryParams = [];
        queryParams.push(`pageSize=100`);

        if (productId) {
            queryParams.push(`productId=${productId}`);
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'PLATFORM_DROPDOWN_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'PLATFORM_DROPDOWN_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }

    getScreenData(productId: any) {
        let url = `${environment.apiUrlDomain}/screens`;
        const queryParams = [];
        queryParams.push(`pageSize=100`);

        if (productId) {
            queryParams.push(`productId=${productId}`);
        }
        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-access-token': this.authData.token,
        };

        this.http
            .getRequest(url, headers)
            .pipe(
                tap((response: any) => {
                    if (response.status == 200) {
                        this.publishSubject.next({
                            type: 'SCREEN_DROPDOWN_SUCCESSFUL',
                            data: response.body,
                        });
                    }
                    console.log(response);
                }),
                catchError((error) => {
                    this.publishSubject.next({
                        type: 'SCREEN_DROPDOWN_FAILED',
                        data: error,
                    });
                    throw error;
                }),
                shareReplay()
            )
            .subscribe();
    }
}
